<template>
    <div class="scroll-y custom-scrollbar">

        <ion-row align-items-start>
        <ion-col size="12" size-md="10" offset-md="1" size-lg="10" offset-lg="1" size-xl="8" offset-xl="2">
            <div class="padding">
                <div class="text-center">

                    <h1 class="h1 text-center">Zadania specjalne</h1>

                    <div v-if="loading" class="loader-wrapper absolute"><span class="loader red"></span></div>
                    <!--<div v-if="loading">
                        <item-specials-skeleton v-for="(item, index) in 3" :key="index"></item-specials-skeleton>
                    </div>-->

                    <transition name="long-fade">
                        <div v-if="!loading && (list && list.length)">
                            <item-special v-for="(item, index) in list" :key="index" :data="item"></item-special>
                        </div>
                    </transition>

                </div>
            </div>
        </ion-col>
        </ion-row>

        <ion-row align-items-start>
            <ion-col size="12">

            </ion-col>
        </ion-row>

    </div>
</template>

<script>


    import SpecialsServices from '../../services/SpecialsServices';
    import ItemSpecial from "../../items/ItemSpecial.vue";
    import ItemSpecialsSkeleton from "../../items/skeleton/ItemSpecial.vue";

    export default {
        name: 'SpecialsList',
        components: {
            ItemSpecialsSkeleton,
            ItemSpecial },
        data: () =>({
            loading: true,
            errors: [],
            data: null
        }),
        computed: {
            list(){
                return this.data || null;
            }
        },
        methods: {
            getData: function () {

                this.loading = true;
                SpecialsServices.getSpecialTasksList()
                    .then( (response) => {
                        this.loading = false;
                        this.data = response.data.data;
                        // FIX scroll to top
                        const element = document.querySelector('#topOfDocument');
                        element.scrollIntoView()
                    })
                    .catch( (e) => {
                        console.log(e.toString())
                        this.errors.push(e.toString())
                    })
            }
        },
        mounted(){
            this.getData();
        }
    }
</script>
